export const defaultPosition = {
  x: 0,
  y: 0,
  w: 80,
  h: 80,
  zIndex: 1,
};
